<template>
  <div class="container-fluid">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "TratamientoDeSuspensiones",
  mounted() {
    this.$store.commit("Suspensiones/setSuspensionesModo", "tratamiento");
  },
};
</script>

<style scoped></style>
